/* Etiquetas multiidoma en castellano. */
export default {
  "confirmFormView.importData": "IMPORTAR DATOS",
  "confirmFormView.qrError.message": "Se ha producido un error al leer el QR: {error}",
  "confirmFormView.qrError.title": "Error de lectura",
  "confirmFormView.qrFormat.message": "El código QR no cumple el formato especificado.",
  "confirmFormView.qrFormat.title": "Error de formato",
};
